// en/channel.js
export const channel = {
  header: {
    title: "Canali di prenotazione",
    subtitle: "Sincronizza o gestisci Booking.com, Expedia, Airbnb e molti altri.",
  },

  establishedConnections: "Connessioni stabilite",

  common: {
    loading: "Caricamento...",
    configure: "Configura",
    close: "Chiudi",
    comingSoon: "Prossimamente",
  },

  alerts: {
    bullets: {
      choosePlan: "Scegli un piano e attiva il tuo Channel Manager.",
      completeProperty: "Completa la configurazione della tua struttura nella dashboard.",
    },
    title: "Azione richiesta",
    planRequired:
      "Devi avere un piano attivo per collegare la tua struttura con una OTA.",
    missingPropertyChannel:
      "Per collegarti con una OTA devi prima completare la configurazione della tua struttura nel Channel Manager.",
  },

  modal: {
    channelHeader: "Connessione del canale con {channel}",
  },

  web: {
    cardTitle: "Prenotazioni dirette dal web",
    // NEW: description for the OTA-style card
    cardDescription:
      "Ricevi prenotazioni dirette dal tuo sito web senza commissioni OTA.",
    // NEW: button texts for card and table
    manageCta: "Gestisci",
    configureCta: "Configura",
    // NEW: label for the ID column of the direct bookings row
    directLinkLabel: "Link di prenotazione diretta",

    linkShareMessage: "Ciao 👋 Puoi prenotare usando questo link:\n\n{link}",
    modalTitle: "Prenotazioni dirette dal web",
    description:
      "Attiva o disattiva le opzioni disponibili per la prenotazione diretta sul tuo sito web. Gli ospiti potranno prenotare direttamente senza intermediari.",
    toggleAllDesktop: "Attiva/Disattiva tutte le prenotazioni web",
    toggleAllMobile: "Attiva/Disattiva",
    table: {
      name: "Nome",
      available: "Disponibile per la prenotazione web",
    },
    capacity: "Capacità",
    people: "persone",
    empty: "Nessun elemento trovato",

    // Link section
    linkTitle: "Il tuo link di prenotazione diretta",
    linkHelp: "Condividi questo link così i tuoi ospiti possono prenotare direttamente",
    linkCopyTooltip: "Copia link",
    linkShareWhatsappTooltip: "Condividi su WhatsApp",
  },

  plan: {
    title: "Attiva il tuo piano per connetterti",
    subtitle:
      "Scegli il piano più adatto alle tue esigenze e abilita la connessione con Booking, Airbnb, Expedia e altri.",
    hint: "Una volta effettuato l'abbonamento, torna qui; sbloccheremo tutti i canali a cui puoi connetterti.",
    cta: "Aggiorna piano",
  },

  toasts: {
    paymentTypeUpdated: "Metodo di pagamento aggiornato con successo",
    linkCopiedTitle: "Copiato!",
    linkCopiedBody: "Link copiato con successo",
    linkCopyErrorTitle: "Errore",
    linkCopyErrorBody: "Si è verificato un errore durante la copia del link",
    save: "Errore durante il salvataggio della configurazione",
    updateWebReservation: "Errore durante l'aggiornamento della prenotazione web",
    saved: "Configurazione salvata con successo",
    updateWebReservationsGlobal:
      "Stato globale delle prenotazioni dirette aggiornato con successo",
  },

  errors: {
    loadData: "Errore durante il caricamento dei dati. Riprova.",
    generateToken: "Errore durante la generazione del token",
    connectChannel: "Errore durante la connessione al canale. Riprova.",
    updatePaymentType: "Errore durante l'aggiornamento del metodo di pagamento",
    save: "Errore durante il salvataggio della configurazione",
    updateWebReservation: "Errore durante l'aggiornamento della prenotazione web",
  },

  tabs: {
    reservations: "Stato della prenotazione",
    payments: "Prezzi e pagamenti",
    share: "Condividi",
  },

  payments: {
    title: "Come vuoi ricevere i pagamenti delle prenotazioni dirette?",
    onArrival: {
      label: "Paga presso la struttura",
      desc: "Gli ospiti pagheranno direttamente all'arrivo",
    },
    online: {
      label: "Prepagamento online",
      desc: "Gli ospiti pagheranno al momento della prenotazione",
    },
  },

  discounts: {
    sectionTitle: "Configura lo sconto per le prenotazioni dirette",
    toggle: "Applica lo sconto alle prenotazioni dirette",
    typeTitle: "Tipo di sconto:",
    percentage: {
      label: "Sconto percentuale",
      desc: "Applica uno sconto percentuale",
    },
    fixed: {
      label: "Sconto a prezzo fisso",
      desc: "Applica uno sconto di importo fisso",
    },
    valueTitle: "Valore dello sconto:",
    placeholderPercentage: "Es: 10",
    placeholderFixed: "Es: 50.00",
    helpPercentage:
      "Inserisci un valore tra 1 e 100 per la percentuale di sconto",
    helpFixed: "Inserisci l'importo fisso in euro da detrarre dal totale",
    previewTitle: "Anteprima:",
    previewPercentage: "Uno sconto del {value}% verrà applicato alle prenotazioni dirette",
    previewFixed: "Uno sconto di €{value} verrà applicato alle prenotazioni dirette",
  },

  buttons: {
    saveChanges: "Salva modifiche",
  },
};
